export default __webpack_public_path__ + "ui/assets/img/transaction-16-info.svg";